import React from "react";
import { Box, Column, Columns, Input, Select, TextArea, Title } from "@allxsmith/bestax-bulma";



export default function DefectJobSection({job, onChange, disabled}){




    return (
      <div>
        <Box>
          <details>
            <summary><Title>Defect Information</Title></summary>
          <Columns isMultiline>
            <Column>
              <label className="label">Status of Vehicle</label>
              <Select
                value={job.defect_status ? job.defect_status : 0}
                disabled={disabled}
                onChange={onChange}
                name={"defect_status"}
              >
                <option value={"DRIVEABLE"} key={"DRIVEABLE"}>DRIVEABLE</option>
                <option value={"NOT_DRIVEABLE"} key={"NOT_DRIVEABLE"}>NOT DRIVEABLE</option>
              </Select>
            </Column>
            <Column>
              <label className="label">Vehicle Location</label>
              <Input
                value={job.location_of_van}
                disabled={disabled}
                onChange={onChange}
                name={"location_of_van"}
              />
            </Column>
            <Column>
              <label className="label">Department</label>
              <Input
                value={job.defect_department ? job.defect_department.name : ""}
                disabled={true}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Driver Name</label>
              <Input
                value={job.defect_driver_name}
                disabled={disabled}
                onChange={onChange}
                name={"defect_driver_name"}
              />
            </Column>
            <Column>
              <label className="label">Driver Phone Number</label>
              <Input
                value={job.defect_driver_number}
                disabled={disabled}
                onChange={onChange}
                name={"defect_driver_number"}
              />
            </Column>
            <Column>
              <label className="label">Defect Creator</label>
              <Input
                disabled={true}
                value={job.defect_creator ? job.defect_creator.first_name + " " + job.defect_creator.last_name : ""}
                name={"defect_creator"}
              />
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <label className="label">Defect Description</label>
              <TextArea
                value={job.defect_description}
                disabled={disabled}
                onChange={onChange}
                name={"defect_description"}
              />
            </Column>
          </Columns>
          </details>
        </Box>
      </div>
    );
}